import { useEffect, useState } from "react";
import { fetchOpcionesMenu } from "../../services/parameter.service";

const useOpcionesAsocionUsuarios = () => {

  const [opcionesAsocionUsuarios, setOpcionesAsocionUsuarios] = useState([]);

  const getOpcionesAsocionUsuarios = async () => {
    try {
      const response = await fetchOpcionesMenu({
        App: "SI",
        Publica: "SI",
        Tipo: "MENUSUARIOS",
      });

      setOpcionesAsocionUsuarios(response.data.list);

    } catch (error) {
      console.error(" ERROR EN getOpcionesAsocionUsuarios --> ", error);
    }
  };

  useEffect(() => {
    getOpcionesAsocionUsuarios();
  }, []);

  return {
    opcionesAsocionUsuarios
  };
};

export default useOpcionesAsocionUsuarios;
